export default {
    Proactive: 0,
    BePrescription: 1,
    CollectionRequest: 2
}